<template>
  <div id="formulario-de-solicitacao">
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <alerta :tipo="'erro'" :texto="mensagemDeErro" />
      <form @submit.prevent="cadastrarSolicitacao">
        <h2 class="titulo titulo_grande">
          Preencha todos os campos obrigatórios abaixo para solicitar o
          subsídio.
        </h2>
        <h3 class="subtitle is-5"><i class="fal fa-user"></i> Pessoas</h3>
        <div>
          <div role="alert" class="mensagem mensagem_cor-atencao">
            <i class="far fa-exclamation-circle mensagem__icone"></i>
            <div class="mensagem__conteudo">
              <h2 class="mensagem__titulo">Atenção:</h2>
              <p class="mensagem__texto">
                Ao conferir a renda do proponente, verifique se é a mesma
                cadastrada. Em caso de divergência atualize a renda no campo
                "Renda familiar comprovada".
                <strong
                  >A irregularidade dessa informação pode levar o processo ao
                  indeferimento</strong
                >
              </p>
            </div>
          </div>
          <div class="grade__linha">
            <div
              v-if="solicitacaoEhDoBonusMoradia"
              class="grade__coluna grade__coluna_2"
            >
              <label class="formulario__label">Renda total apurada</label>
              <span>{{ solicitacao.RendaTotalComprovada }}</span>
            </div>
            <div class="grade__coluna grade__coluna_2">
              <label class="formulario__label">Renda familiar cadastrada</label>
              <span>{{ somatorioDaRenda }}</span>
            </div>
          </div>
          <div v-for="(proponente, index) in solicitacao.Proponentes">
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_5">
                <label class="formulario__label"
                  >{{ index + 1 }}º Proponente</label
                >
                <span>{{ proponente.Nome }}</span>
              </div>
              <div class="grade__coluna grade__coluna_3">
                <label class="formulario__label">CPF</label>
                <span>{{ proponente.Cpf }}</span>
              </div>
              <div class="grade__coluna grade__coluna_2">
                <label class="formulario__label">Telefone</label>
                <span>{{ proponente.Telefone || "Não informado" }}</span>
              </div>
              <div
                v-if="!solicitacaoEhDoBonusMoradia"
                class="grade__coluna grade__coluna_2"
              >
                <label class="formulario__label">Renda</label>
                <span>{{ formatarMonetario(proponente.Renda) }}</span>
              </div>
            </div>

            <div class="grade__linha" v-if="proponente.Conjuge">
              <div class="grade__coluna grade__coluna_5">
                <label class="formulario__label"
                  >Cônjuge ({{ index + 1 }}º Proponente)</label
                >
                <span>{{ proponente.Conjuge.Nome }}</span>
              </div>
              <div class="grade__coluna grade__coluna_3">
                <label class="formulario__label">CPF</label>
                <span>{{ proponente.Conjuge.Cpf }}</span>
              </div>
              <div class="grade__coluna grade__coluna_2">
                <label class="formulario__label">Telefone</label>
                <span>{{
                  proponente.Conjuge.Telefone || "Não informado"
                }}</span>
              </div>
              <div
                v-if="!solicitacaoEhDoBonusMoradia"
                class="grade__coluna grade__coluna_2"
              >
                <label class="formulario__label">Renda</label>
                <span>{{ formatarMonetario(proponente.Conjuge.Renda) }}</span>
              </div>
            </div>
          </div>
        </div>
        <h3 class="subtitle is-5">
          <i class="fal fa-home"></i> Empreendimento
        </h3>
        <div class="">
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label">Cidade</label>
              <p class="control is-expanded">
                <span>{{ this.cidade.Nome }}</span>
              </p>
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label">Empreendimento</label>
              <select
                class="formulario__input"
                v-model="solicitacao.EmpreendimentoId"
                required
              >
                <option
                  v-for="empreendimento in empreendimentos"
                  :value="empreendimento.Id"
                  :selected="
                    empreendimento.Id === solicitacao.EmpreendimentoId
                      ? 'selected'
                      : ''
                  "
                >
                  {{ empreendimento.Nome }}
                </option>
              </select>
            </div>
            <div
              class="grade__coluna grade__coluna_2"
              v-if="ehEmpreendimentoDeCasaEApartamento()"
            >
              <label class="formulario__label">Tipo do imóvel</label>
              <select
                v-model="solicitacao.TipoDeImovel"
                required
                class="formulario__input"
              >
                <option
                  v-for="tipoDeImovel in tiposDeImovel"
                  :value="tipoDeImovel.Id"
                  :selected="
                    tipoDeImovel.Id === solicitacao.TipoDeImovel
                      ? 'selected'
                      : ''
                  "
                >
                  {{ tipoDeImovel.Nome }}
                </option>
              </select>
            </div>
          </div>
          <div class="grade__linha" v-if="empreendimentoEstaSelecionado()">
            <div class="grade__coluna grade__coluna_5">
              <label class="formulario__label">Construtora</label>
              <span>{{ construtora.Nome }}</span>
            </div>
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label">CNPJ</label>
              <span>{{ construtora.Cnpj }}</span>
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label">Conta</label>
              <span>{{ construtora.Conta }}</span>
            </div>
          </div>
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label" for="cep">CEP</label>
              <input
                name="cep"
                type="tel"
                id="cep"
                class="formulario__input"
                placeholder="Somente números"
                v-model="solicitacao.Cep"
                v-mask="'99999-999'"
                required
              />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="tipo-do-logradouro"
                >Tipo do logradouro</label
              >
              <select
                class="formulario__input"
                v-model="solicitacao.TipoDeLogradouroId"
                required
              >
                <option
                  v-for="tipoDeLogradouro in tiposDeLogradouro"
                  :value="tipoDeLogradouro.Id"
                  :selected="
                    tipoDeLogradouro.Id === solicitacao.TipoDeLogradouroId
                      ? 'selected'
                      : ''
                  "
                >
                  {{ tipoDeLogradouro.Nome }}
                </option>
              </select>
            </div>
            <div class="grade__coluna grade__coluna_5">
              <label class="formulario__label" for="logradouro"
                >Logradouro</label
              >
              <input
                id="logradouro"
                class="formulario__input"
                type="text"
                maxlenght="90"
                name="logradouro"
                placeholder="Ex: Afonso Pena, da Divisão, Lídia Baís, etc."
                v-model="solicitacao.Logradouro"
                required
              />
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_2">
                <label class="formulario__label" for="numero">Número</label>
                <input
                  id="numero"
                  class="formulario__input"
                  type="number"
                  placeholder="EX: 481"
                  v-model="solicitacao.Numero"
                  number
                  required
                />
              </div>

              <div class="grade__coluna grade__coluna_3">
                <label class="formulario__label" for="bairro">Bairro</label>
                <input
                  id="bairro"
                  class="formulario__input"
                  name="bairro"
                  type="text"
                  maxlenght="90"
                  placeholder="Ex: Centro, Santa Fé, Vila Carvalho..."
                  v-model="solicitacao.Bairro"
                  required
                />
              </div>
              <div
                class="grade__coluna grade__coluna_1"
                v-if="empreendimentoEstaSelecionado()"
              >
                <label
                  class="formulario__label"
                  for="bloco"
                  v-if="ehEmpreendimentoDeApartamento()"
                  >Bloco
                </label>
                <label class="formulario__label" for="quadra" v-else
                  >Quadra/Bloco
                </label>
                <input
                  id="quadra"
                  class="formulario__input"
                  v-model="solicitacao.BlocoOuQuadra"
                  type="text"
                  maxlenght="90"
                  placeholder="Ex: 1"
                  required
                />
              </div>
              <div
                class="grade__coluna grade__coluna_2"
                v-if="empreendimentoEstaSelecionado()"
              >
                <label
                  class="formulario__label"
                  for="apartamento"
                  v-if="ehEmpreendimentoDeApartamento()"
                  >Apartamento
                </label>
                <label class="formulario__label" for="lote" v-else
                  >Lote/Apartamento</label
                >
                <input
                  id="lote"
                  class="formulario__input"
                  v-model="solicitacao.ApartamentoOuLote"
                  type="text"
                  maxlenght="90"
                  placeholder="Ex: A"
                  required
                />
              </div>
              <div class="grade__coluna grade__coluna_4">
                <label class="formulario__label" for="complemento"
                  >Complemento <span>(Preenchimento é opcional)</span></label
                >
                <input
                  id="complemento"
                  class="formulario__input"
                  type="text"
                  maxlenght="90"
                  placeholder="Ex: casa 2"
                  v-model="solicitacao.Complemento"
                />
              </div>
            </div>
          </div>
        </div>

        <h3 class="subtitle is-5">
          <i class="fal fa-sack-dollar"></i> Dados do financiamento
        </h3>
        <div class="">
          <div class="">
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_4">
                <label class="formulario__label" for="valor-da-compra-e-venda">
                  Valor de Comercialização
                  <span class="tooltips">
                    <i
                      class="fa fa-info-circle"
                      id="tooltipValorDoFinanciamento"
                      aria-hidden="true"
                    ></i>
                    <span class="conteudo tooltip-top"
                      >O valor de comercialização, é o total da soma de todos os
                      campos em destaque.
                    </span>
                  </span>
                </label>
                <input
                  id="valor-da-compra-e-venda"
                  class="formulario__input"
                  type="text"
                  placeholder="130.000,00"
                  v-model="solicitacao.ValorDaCompraEVenda"
                  v-mask="'money'"
                  required
                />
              </div>
              <div class="grade__coluna grade__coluna_4">
                <label class="formulario__label" for="valor-de-avaliacao"
                  >Valor de avaliação</label
                >
                <input
                  id="valor-de-avaliacao"
                  class="formulario__input destacar-campos"
                  type="text"
                  placeholder="130.000,00"
                  v-model="solicitacao.ValorDeAvaliacao"
                  v-mask="'money'"
                  required
                />
              </div>
              <div class="grade__coluna grade__coluna_4">
                <label
                  class="formulario__label"
                  for="valor-do-financiamento-aprovado"
                  >Valor do financiamento concedido</label
                >
                <input
                  id="valor-do-financiamento-aprovado"
                  class="formulario__input destacar-campos"
                  type="text"
                  placeholder="90.000,00"
                  v-model="solicitacao.ValorDoFinanciamentoAprovado"
                  v-mask="'money'"
                  required
                />
              </div>
            </div>
          </div>
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="subsidio-governo-federal"
                >Subsídio Governo Federal</label
              >
              <input
                id="subsidio-governo-federal"
                class="formulario__input destacar-campos"
                type="text"
                placeholder="14.000,00"
                v-model="solicitacao.SubsidioDoGovernoFederal"
                v-mask="'money'"
              />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="codigo-de-avaliacao"
                >Código de avaliação</label
              >
              <input
                id="codigo-de-avaliacao"
                class="formulario__input"
                type="number"
                placeholder="Somente números"
                v-model="solicitacao.CodigoDeAvaliacao"
                number
                required
              />
            </div>
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label" for="data-de-avaliacao"
                >Data de avaliação</label
              >
              <input
                id="data-de-avaliacao"
                class="formulario__input"
                type="date"
                v-model="solicitacao.DataDeAvaliacao"
                required
              />
            </div>
          </div>
          <div class="grade__linha">
            <p>
              <strong> Recursos Próprios </strong>
            </p>
          </div>
          <div class="grade__linha">
            <div
              v-if="solicitacaoEhDoBonusMoradia"
              class="grade__coluna grade__coluna_4"
            >
              <label class="formulario__label" for="desconto-da-construtora"
                >Desconto da construtora na entrada
              </label>
              <input
                id="desconto-da-construtora"
                class="formulario__input destacar-campos"
                type="text"
                placeholder="10.000,00"
                v-model="solicitacao.DescontoConstrutora"
                v-mask="'money'"
              />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="participacao-necessaria"
                >Participação do proponente</label
              >
              <input
                id="participacao-necessaria"
                class="formulario__input destacar-campos"
                type="text"
                placeholder="10.000,00"
                v-model="solicitacao.ParticipacaoDoSolicitante"
                v-mask="'money'"
              />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="subsidio-solicitado-agehab"
                >Subsídio solicitado AGEHAB</label
              >
              <input
                id="subsidio-solicitado-agehab"
                class="formulario__input destacar-campos"
                type="text"
                placeholder="6.000,00"
                v-model="solicitacao.SubsidioDaAgehab"
                v-mask="'money'"
                disabled
              />
            </div>
            <div
              v-if="!solicitacaoEhDoBonusMoradia"
              class="grade__coluna grade__coluna_4"
            >
              <label class="formulario__label" for="valor-do-fgts"
                >Valor do FGTS do proponente
                <span>(Preenchimento da informação é opcional)</span></label
              >
              <input
                id="valor-do-fgts"
                class="formulario__input destacar-campos"
                type="text"
                placeholder="10.000,00"
                v-model="solicitacao.FgtsDoSolicitante"
                v-mask="'money'"
              />
            </div>
          </div>
        </div>
        <div class="grade__linha">
          <router-link
            to="/consulta-por-cpf"
            class="botao botao_cinza botao_medio"
            :class="{ 'is-disabled': loading.visivel }"
            >Cancelar</router-link
          >
          <button
            type="submit"
            :disabled="
              estaEmProcessoDeCadastroDaSolicitacao ||
              !solicitacao.SubsidioDaAgehab
            "
            class="botao botao_medio botao_cor-terciaria u-margem-esquerda-media"
            :class="{ 'is-loading': loading.visivel }"
          >
            Solicitar subsídio
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Alerta from "../shared/Alerta";
import Loading from "../shared/Loading";

export default {
  name: "formulario-de-solicitacao",
  directives: { mask: AwesomeMask },
  components: { Alerta, Loading },
  data() {
    return {
      estaEmProcessoDeCadastroDaSolicitacao: false,
      loading: { visivel: false },
      mensagemDeErro: null,
      proponentes: [],
      cidade: this.cidade,
      empreendimentos: this.empreendimentos || [],
      tiposDeLogradouro: this.tiposDeLogradouro || [],
      solicitacaoEhDoBonusMoradia: false,
      tiposDeImovel: [
        {
          Id: null,
          Nome: "Selecione um tipo de imóvel",
        },
        {
          Id: 1,
          Nome: "Apartamento",
        },
        {
          Id: 2,
          Nome: "Casa",
        },
      ],
      solicitacao: {
        Proponentes: this.proponentes,
        RendaTotalComprovada: this.$moeda.formatar(
          this.$localStorage.obter("rendaFamiliarComprovada")
        ),
        ProjetoId: this.$route.params.projetoId,
        EmpreendimentoId: null,
        Cep: null,
        Bairro: null,
        TipoDeLogradouroId: null,
        Logradouro: null,
        Numero: null,
        BlocoOuQuadra: null,
        ApartamentoOuLote: null,
        Complemento: null,
        CodigoDeAvaliacao: null,
        ValorDaCompraEVenda: null,
        ValorDoFinanciamentoAprovado: null,
        FgtsDoSolicitante: null,
        ParticipacaoDoSolicitante: null,
        SubsidioDoGovernoFederal: null,
        SubsidioDaAgehab: null,
        TipoDeImovel: null,
        DescontoConstrutora: null,
        DataDeAvaliacao: null,
        ValorDeAvaliacao: null,
      },
    };
  },
  watch: {
    "solicitacao.EmpreendimentoId"(empreendimentoId) {
      if (!empreendimentoId) {
        this.solicitacao.SubsidioDaAgehab = null;
        return;
      }
      this.obterValorDoSubsidio(empreendimentoId);
    },
  },
  computed: {
    construtora() {
      const empreedimentoId = this.solicitacao.EmpreendimentoId;
      const empreendimento = this.empreendimentos.find(
        (e) => e.Id === empreedimentoId
      );
      return empreendimento ? empreendimento.Construtora : {};
    },
    somatorioDaRenda() {
      let somatorioDeRenda = 0;
      this.solicitacao.Proponentes.forEach((prop) => {
        somatorioDeRenda += somarRendaDosProponentes(prop);
      });
      return this.$moeda.formatar(somatorioDeRenda);

      function somarRendaDosProponentes(proponente) {
        let rendaDoTitular = proponente.Renda;
        let rendaDoConjuge =
          proponente.Conjuge != null ? proponente.Conjuge.Renda : 0;
        let somatorioDaRenda = rendaDoTitular + rendaDoConjuge;
        return somatorioDaRenda;
      }
    },
  },
  mounted() {
    const tooltip = document.getElementById("tooltipValorDoFinanciamento");
    tooltip.onmouseover = () => {
      const camposDeValor = document.querySelectorAll(".destacar-campos");
      for (let i = 0; i < camposDeValor.length; i += 1) {
        camposDeValor[i].className += " habilitado";
      }
    };

    tooltip.onmouseleave = () => {
      const camposDeValor = document.querySelectorAll(".destacar-campos");
      for (let i = 0; i < camposDeValor.length; i += 1) {
        camposDeValor[i].classList.remove("habilitado");
      }
    };
  },
  beforeCreate() {
    this.proponentes = this.$localStorage.obter("proponentes");

    if (this.proponentes.length == 0)
      this.$router.push({ name: "ConsultaPorCpf" });

    this.cidade = this.proponentes[0].Cidade;
    this.$api
      .get("/Empreendimento/", {
        cidadeId: this.cidade.Id,
        projetoId: this.$route.params.projetoId,
      })
      .then((response) => {
        this.empreendimentos = [
          { Id: null, Nome: "Selecione um empreedimento" },
        ];
        this.empreendimentos = this.empreendimentos.concat(response.data);
        this.solicitacaoEhDoBonusMoradia =
          response.data[0].ProjetoEhBonusMoradia;
        return response;
      })
      .catch((error) => {
        console.error(error);
      });

    this.$api.get("/TipoDeLogradouro").then(
      (response) => {
        this.tiposDeLogradouro = [{ Id: null, Nome: "Selecione um tipo" }];
        this.tiposDeLogradouro = this.tiposDeLogradouro.concat(response.data);
      },
      (error) => {
        console.error(error);
      }
    );
  },
  methods: {
    obterValorDoSubsidio(empreendimentoId) {
      const dto = {
        ProjetoId: this.solicitacao.ProjetoId,
        CidadeId: this.cidade.Id,
        RendaComprovada: this.$moeda.removerFormatacao(
          this.solicitacao.RendaTotalComprovada
        ),
        EmpreendimentoId: empreendimentoId,
      };
      this.exibirCarregamento();
      this.$api
        .post("/Projeto/ObterValorDoSubsidio", dto)
        .then((resposta) => {
          this.esconderCarregamento();
          const resultado =
            resposta && resposta.data && resposta.data.Resultado
              ? resposta.data.Resultado
              : null;
          if (resultado === null) {
            this.exibirMensagemDeErro(
              "A renda é incompatível com o projeto de subsídio"
            );
            this.solicitacao.SubsidioDaAgehab = null;
          } else {
            this.solicitacao.SubsidioDaAgehab = this.$moeda.formatar(
              resultado.Valor
            );
          }
        })
        .catch((error) => {
          this.esconderCarregamento();
          const mensagensDeErro =
            error.response && error.response.data
              ? error.response.data.Message
              : null;
          this.exibirMensagemDeErro(
            mensagensDeErro || "Ocorreu um erro ao obter o valor do subsídio"
          );
          this.solicitacao.SubsidioDaAgehab = null;
        });
    },
    cadastrarSolicitacao() {
      if (this.estaEmProcessoDeCadastroDaSolicitacao) {
        return;
      }

      this.estaEmProcessoDeCadastroDaSolicitacao = true;
      this.exibirCarregamento();

      this.configurarTipoDoImovel();
      const solicitacao = JSON.parse(JSON.stringify(this.$data.solicitacao));

      solicitacao.ValorDeAvaliacao = this.$moeda.removerFormatacao(
        solicitacao.ValorDeAvaliacao
      );
      solicitacao.ValorDaCompraEVenda = this.$moeda.removerFormatacao(
        solicitacao.ValorDaCompraEVenda
      );
      solicitacao.ValorDoFinanciamentoAprovado = this.$moeda.removerFormatacao(
        solicitacao.ValorDoFinanciamentoAprovado
      );
      solicitacao.FgtsDoSolicitante = this.$moeda.removerFormatacao(
        solicitacao.FgtsDoSolicitante
      );
      solicitacao.ParticipacaoDoSolicitante = this.$moeda.removerFormatacao(
        solicitacao.ParticipacaoDoSolicitante
      );
      solicitacao.SubsidioDoGovernoFederal = this.$moeda.removerFormatacao(
        solicitacao.SubsidioDoGovernoFederal
      );
      solicitacao.SubsidioDaAgehab = this.$moeda.removerFormatacao(
        solicitacao.SubsidioDaAgehab
      );
      solicitacao.RendaTotalComprovada = this.$moeda.removerFormatacao(
        solicitacao.RendaTotalComprovada
      );
      solicitacao.DescontoConstrutora = this.$moeda.removerFormatacao(
        solicitacao.DescontoConstrutora
      );
      this.$api
        .post("/solicitacao", solicitacao)
        .then((response) => {
          const idDaSolicitacao = response.data;
          this.$localStorage.remover("proponentes");
          this.$router.push({
            name: "VisualizarSolicitacao",
            query: { idDaSolicitacao },
          });
        })
        .catch((error) => {
          const mensagensDeErro = error.response.data.Message;
          this.esconderCarregamento();

          if (mensagensDeErro) {
            this.exibirMensagemDeErro(
              mensagensDeErro.split(",").join("<br />")
            );
          } else {
            this.exibirMensagemDeErro(
              "Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte"
            );
          }

          this.estaEmProcessoDeCadastroDaSolicitacao = false;
          window.scrollTo(0, 0);
        });
    },
    exibirCarregamento() {
      this.loading.visivel = true;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
    },
    configurarTipoDoImovel() {
      if (this.ehEmpreendimentoDeApartamento()) {
        this.solicitacao.TipoDeImovel = 1;
      } else {
        this.solicitacao.TipoDeImovel = 2;
      }
    },
    empreendimentoEstaSelecionado() {
      return this.solicitacao.EmpreendimentoId !== null;
    },
    exibirMensagemDeErro(mensagem) {
      this.mensagemDeErro = mensagem;
    },
    ocultarMensagemDeErro() {
      this.mensagemDeErro = null;
    },
    formatarMonetario(valor) {
      return this.$moeda.formatar(valor);
    },
    obterEmpreendimento() {
      const empreedimentoId = this.solicitacao.EmpreendimentoId;
      return this.empreendimentos.find((e) => e.Id === empreedimentoId);
    },
    obterTipoDeImovel() {
      const tipoDeImovelId = this.solicitacao.TipoDeImovel;
      return this.tiposDeImovel.find((e) => e.Id === tipoDeImovelId);
    },
    ehEmpreendimentoDeApartamento() {
      if (this.ehEmpreendimentoDeCasaEApartamento()) {
        const tipoDeImovel = this.obterTipoDeImovel();
        return tipoDeImovel !== null && tipoDeImovel.Id === 1;
      }
      const empreendimento = this.obterEmpreendimento();
      return empreendimento.TipoDeEmpreendimentoId === 1;
    },
    ehEmpreendimentoDeCasaEApartamento() {
      const empreedimento = this.obterEmpreendimento();
      return (
        empreedimento != null &&
        empreedimento.TipoDeEmpreendimentoId === 3 &&
        this.empreendimentoEstaSelecionado()
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// FormularioDeSolicitacao.vue?1a0e3acd